export const SnackbarMap = {
	SNACKBAR_SUCCESS: 'SNACKBAR_SUCCESS',
	SNACKBAR_CLEAR: 'SNACKBAR_CLEAR',
}

export const SnackbarActions = {
	snackbarSuccess: (data) => ({ type: SnackbarMap.SNACKBAR_SUCCESS, payload: data }),
	snackbarClear: (data) => ({ type: SnackbarMap.SNACKBAR_CLEAR, payload: data }),
}